<template>
  <div>
    <section class="section section-white content-padded-b" v-loading="loading">
      <div v-if="wxapp_id && detail && detail.weapp && detail.weappTemplate">
        <div class="content-center">
          <div v-if="detail.head_img">
            <img class="app-img" :src="wximageurl + detail.head_img" height="60"/>
          </div>
          <div v-else>
            <i class="iconfont icon-image fa-3x" aria-hidden="true"></i>
          </div>
          <div class="app-name" v-if="detail.nick_name">
            {{detail.nick_name}}
          </div>
          <div class="demo">
            <div class="demo-qrcode" v-if="detail.weapp.release_status == '1' && detail.weapp.release_ver" @click="downloadWxaCode"><img src="../../../../static/img/code.png" alt=""></div>
          </div>
        </div>
        <ul class="info-list">
          <li class="info-item">
            <div class="label">模板</div>
            <div class="content">
              <div class="content-item">{{detail.weappTemplate.name}}</div>
              <div>线上版本：{{detail.weapp.release_ver}}</div>
            </div>
          </li>
          <li class="info-item">
            <div class="label">版本</div>
            <div class="content">
              <div class="content-item">{{detail.weappTemplate.version}}</div>
              <div>
                <div v-if="detail.weappTemplate.template_id > detail.weapp.template_id">请更新到最新版本。
                 新流程：1从草稿列表中选择需要上传添加到模板列 2从模板列表中选择选中的使用模板 3先上传代
                 4.再提交审核（成功后会短信提醒指定人员）
                 5.发布（如果是小版本迭代直接发布、 如果是大版本可以选择分阶段发布按照 分阶段发布体验人员->全部人员）
                  6.如果有异常可以选择版本回退，回退注意版本描述

                </div>
                <div v-else>当前已是最新版本 。1从草稿列表中选择需要上传添加到模板列 2从模板列表中选择选中的使用模板 3先上传代码 4再提交审核（成功后会短信提醒指定人员）。
                  5.发布（如果是小版本迭代直接发布、 如果是大版本可以选择分阶段发布按照 分阶段发布体验人员->全部人员）
                  6.如果有异常可以选择版本回退，回退注意版本描述
                </div>
              </div>
            </div>
          </li>
          <li class="info-item">
            <div class="label">上架状态</div>
            <div class="content">
              <div class="content-item">
                <span v-if="detail.weapp.release_status == '1'">已上架</span>
                <span v-else type="gray">未上架</span>
              </div>
            </div>
          </li>
          <li class="info-item" v-if="detail.weapp.release_status != '1'" >
            <div class="label">审核状态</div>
            <div class="content">
              <div class="content-item">
                <span v-if="detail.weapp.audit_status == '1'">审核失败</span>
                <!--审核成功并且已经上架则不需要显示-->
                <span v-else-if="detail.weapp.audit_status == '0' && detail.weapp.release_status != '1'" type="success">审核成功</span>
                <span v-else-if="detail.weapp.audit_status == '2'" type="primary">审核中</span>
              </div>
            </div>
          </li>
          <li class="info-item" v-if="detail.weapp.audit_status == '1' && detail.weapp.reason">
            <div class="label">审核失败原因</div>
            <div class="content">
              <div class="content-item" v-html="detail.weapp.reason"></div>
            </div>
          </li>
        </ul>
        <div class="content-center">
          
          <el-button type="primary" @click="handleBind">更新授权</el-button>

          <br><br><br>
          <el-button @click="handleCGtemplateList">代码草稿列表 </el-button>
          <el-button @click="handletemplateList">查看模板列表 </el-button>
         
          <el-button type="success" v-if="detail.weappTemplate.template_id > detail.weapp.template_id" @click="handleAddWxaAction">更新小程序</el-button>
          <el-button type="success" v-else-if="isForceUpdate || detail.weapp.audit_status === 1" @click="handleAddWxaAction">重新提交</el-button>
          
         
          <!--先上传代码 再提交审核-->
          <el-button type="primary" @click="handleAddWxaAction1">上传代码</el-button>
          <br><br><br>

          <el-button type="primary"  @click="handleAddWxaAction2">提交审核</el-button>
          <br><br><br>

          <el-button type="success"   @click="tryRelease">尝试发布</el-button>
          <!-- <el-button type="info"  @click="handleAddWxaAction3">发布</el-button> -->
          <el-button type="success"  @click="handleAddWxaAction4">分阶段发布体验成员</el-button>
          <el-button type="success"  @click="handleAddWxaAction5">分阶段发布全部</el-button>
          <el-button type="success"  @click="handleAddWxaAction6">分阶段发布详情</el-button>
          <el-button type="success"  @click="handleAddWxaAction8">取消分阶段发布</el-button>
          <br><br><br>
          <el-button  type="warning"  @click="getLastAuditStatus">查看最近一次审核状态</el-button>

          <el-button type="warning" @click="getListrevertcoderelease">查看可回退版本 </el-button>

          <el-button type="warning" v-if="detail.weapp.audit_status === 2" @click="handleUndocodeaudit">审核撤回</el-button>
          <el-button type="warning" v-if="detail.weapp.audit_status === 0" @click="handleRevertcoderelease">回退版本</el-button>
          <br><br><br>
         
          <!--查看体验二维码-->
          <el-button type="info"  @click="downloadTextWxaCode">体验二维码</el-button>
          <el-button type="info"  @click="handleAddWxaAction7">当前版本</el-button>
        </div>
      </div>
      <div class="content-center no-bind" v-else>
        <div><i class="iconfont icon-info-circle" style="font-size: 70px;"></i></div>
        <div class="content-padded">未绑定小程序</div>
        <el-button type="primary" @click="handleBind">授权小程序</el-button>
      </div>
    </section>
    <el-dialog title="小程序码" :visible.sync="wxaCodeVisible">
      <div class="content-center">
        <img :src="wxaCodeImage">
      </div>
    </el-dialog>
    <sideBar :visible.sync="showCG" title="草稿列表" width="60">
        <div class="content-bottom-padded">
          <el-alert type="info" title="" show-icon>
            <div>
              选择草稿列表保存到模板库
            </div>
          </el-alert>
        </div>

        <el-table :data="CGTemlplate" v-loading="skuLoading" height="100%">
          <el-table-column label="版本号" prop="user_version" min-width="100">
          </el-table-column>
          <el-table-column label="描述" prop="user_desc" min-width="100">
          </el-table-column>
          <el-table-column label="来源小程序" prop="source_miniprogram" min-width="100">
          </el-table-column>
          <el-table-column label="最近上传开发者" prop="developer" min-width="100">
          </el-table-column>
          <el-table-column label="最近提交时间" prop="create_time" min-width="100">
            <template slot-scope="scope">
            
            {{scope.row.create_time | datetime('yyyy-MM-dd hh:mm:ss')}}
            </template>
           
          </el-table-column>

          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="primary" @click="addCgToTemp(scope.row.draft_id)" :loading="addToTemplLoad">添加到模板库
              </el-button>
            </template>
          </el-table-column>

        </el-table>
       
     </sideBar>

     <sideBar :visible.sync="showTM" title="草稿列表" width="60">
        <div class="content-bottom-padded">
          <el-alert type="info" title="" show-icon>
            <div>
              模板列表
            </div>
          </el-alert>
        </div>

        <el-table :data="Templatelist" v-loading="skuLoading" height="100%">
          <el-table-column label="版本号" prop="user_version" min-width="80">
          </el-table-column>
          <el-table-column label="模板 id" prop="template_id" min-width="80">
          </el-table-column>
          <el-table-column label="描述" prop="user_desc" min-width="80">
          </el-table-column>
          <el-table-column label="来源小程序" prop="source_miniprogram" min-width="80">
          </el-table-column>
          <el-table-column label="最近上传开发者" prop="developer" min-width="80">
          </el-table-column>
          <el-table-column label="上传时间" prop="create_time" min-width="80">
            <template slot-scope="scope">
            {{scope.row.create_time | datetime('yyyy-MM-dd hh:mm:ss')}}
            </template>
          </el-table-column>

          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="primary" @click="useThisTemplate(scope.row.user_version,scope.row.template_id)" :loading="addToTemplLoad">使用当前模板
              </el-button>
            </template>
          </el-table-column>

        </el-table>
       
     </sideBar>

     <sideBar :visible.sync="showRevertReleas" title="可回退小程序版本" width="60">
        <div class="content-bottom-padded">
          <el-alert type="info" title="" show-icon>
            <div>
              可回退列表
            </div>
          </el-alert>
        </div>

        <el-table :data="CanRevertRelasList" v-loading="skuLoading" height="100%">
          <el-table-column label="版本号" prop="user_version" min-width="80">
          </el-table-column>
          <el-table-column label="描述" prop="user_desc" min-width="80">
          </el-table-column>
          <el-table-column label="小程序版本" prop="app_version" min-width="80">
          </el-table-column>
          <el-table-column label="更新时间" prop="commit_time" min-width="80">
            <template slot-scope="scope">
            {{scope.row.commit_time | datetime('yyyy-MM-dd hh:mm:ss')}}
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="primary" @click="versionRevertcoderelease(scope.row.app_version)" :loading="addToTemplLoad">回退到该版本
              </el-button>
            </template>
          </el-table-column>

        </el-table>
       
     </sideBar>

  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { getWechatPreAuthUrl } from '../../../api/wechat'
  import { useTempList,getWxaAuditStatus,grayReleaseDebug,grayReleaseAll,getgrayReleaseDetail,revertGrayRelase,
    getListrevertcoderelease,versionRevertcoderelease,getnowVersion,
    getLastAuditStatus,getCgList,addCg2Temp,getTempList,getWxa, submitWxa,submitWxa1,submitWxa2, getCodeUnlimit, getTestQrcode, tryRelease, revertcoderelease, undocodeaudit } from '../../../api/wxa'
 
  import sideBar from '@/components/element/sideBar'
  export default {
    components: {
      sideBar
    },
    data () {
      return {
        isForceUpdate: false,
        wxaCodeVisible: false,
        loading: false,
        getwxcodeloading: false,
        authorizerUrl: '',
        wxaCodeImage: '',
        templateName: '',
        submitWeappForm: {
          wxaAppId: '',
          templateName: '',
          wxa_name: ''
        },
        detail: {},
        showCG: false,
        skuLoading:false,
        addToTemplLoad:false,
        CGTemlplate:[],
        showTM:false,
        Templatelist:[],
        showRevertReleas:false,
        CanRevertRelasList:[],
      }
    },
    computed: {
      ...mapGetters([
        'wxapp_id',
        'template_name'
      ])
    },
    methods: {
      handleBind () {
        let params = {
          callback_url: this.wxAuthCallbackUrl + 'auth/wxa'
        }
        getWechatPreAuthUrl(params).then(response => {
          this.authorizerUrl = response.data.data.url
          var metadata = document.getElementsByTagName("meta");
          for(var i=0; i<metadata.length; i++) {
            if(metadata[i]["name"] == "referrer") {
              metadata[i]["content"] = "default"
            }
          }
          window.open(this.authorizerUrl, '_self')
        })
      },
      getWxa () {
        this.loading = true
        getWxa(this.wxapp_id).then(response => {
          this.detail = response.data.data
          this.loading = false
        })
      },
      handleCGtemplateList(){
        this.showCG = true;
        this.handlecgtemplateList()
      },
      handletemplateList(){
        this.showTM = true;
        this.handTemplateList()
      },
      // 代码草稿列
      handlecgtemplateList (){
        getCgList({wxaAppId:this.wxapp_id}).then(response => {
          this.CGTemlplate = response.data.data.data
        })
      },
      // 将草稿列加入模板库
      addCgToTemp (draft_id){
        addCg2Temp({draft_id:draft_id}).then(response => {
          var status = response.data.data.status
          var msg = response.data.data.errmsg
          if (status == true) {
            this.$message.success('添加成功!')
          }else{
            this.$message.error('添加失败'+msg)
          }
        })
      },
      // 模板列表
      handTemplateList (){
        getTempList().then(response => {
          this.Templatelist = response.data.data.data
        })
      },
      // 使用当前模板
      useThisTemplate (user_version,template_id){
        useTempList({'user_version':user_version,'template_id':template_id}).then(response => {
          var status = response.data.data.status
          if (status == true) {
            this.$message.success('使用成功!')
          }else{
            this.$message.error('使用失败')
          }
        })
      },
      // 撤销审核
      handleUndocodeaudit () {
        this.$confirm('单个帐号每天审核撤回次数最多不超过1次，一个月不超过10次, 是否撤销审核?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          undocodeaudit({wxaAppId: this.detail.authorizer_appid}).then(response => {
            this.$message({
              message: '撤销成功',
              type: 'success',
              duration: 2 * 1000
            })
            this.getWxa()
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
      },
      // 回退版本
      handleRevertcoderelease () {
        this.$confirm('回退到上一个小程序版本, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          revertcoderelease({wxaAppId: this.detail.authorizer_appid}).then(response => {
            this.$message({
              message: '回退成功',
              type: 'success',
              duration: 2 * 1000
            })
            this.getWxa()
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
      },
      // 上架小程序
      handleAddWxaAction () {
        this.submitWeappForm.wxaAppId = this.detail.authorizer_appid
        this.submitWeappForm.wxa_name = this.detail.nick_name
        this.submitWeappForm.templateName = this.detail.weapp.template_name

        if (this.isForceUpdate) {
          this.$confirm('将重新提交小程序, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
          }).then(() => {
            submitWxa(this.submitWeappForm).then(response => {
              this.$message({
                message: '提交成功，等待微信审核',
                type: 'success',
                duration: 5 * 1000
              })
              this.getWxa()
            })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消'
            })
          })
        } else {
          submitWxa(this.submitWeappForm).then(response => {
            this.$message({
              message: '提交成功，等待微信审核',
              type: 'success',
              duration: 5 * 1000
            })
            this.getWxa()
          })
        }
      },
      // 上传代码
      handleAddWxaAction1 () {
            this.submitWeappForm.wxaAppId = this.detail.authorizer_appid
            this.submitWeappForm.wxa_name = this.detail.nick_name
            this.submitWeappForm.templateName = this.detail.weapp.template_name
            submitWxa1(this.submitWeappForm).then(response => {
                this.$message({
                    message: '上传小程序代码成功',
                    type: 'success',
                    duration: 5 * 1000
                })
                this.getWxa()
            })
        },
        // 提交审核
        handleAddWxaAction2 () {
            this.submitWeappForm.wxaAppId = this.detail.authorizer_appid
            this.submitWeappForm.wxa_name = this.detail.nick_name
            this.submitWeappForm.templateName = this.detail.weapp.template_name
            submitWxa2(this.submitWeappForm).then(response => {
                this.$message({
                    message: '提交小程序代码成功，等待审核',
                    type: 'success',
                    duration: 5 * 1000
                })
                this.getWxa()
            })
        },
      downloadTextWxaCode () {
        let params = {wxaAppId: this.detail.authorizer_appid}
        getTestQrcode(params).then(response => {
          this.wxaCodeImage = response.data.data.base64Image
          this.wxaCodeVisible = true
        })
      },
      //分阶段发布体验成员
      handleAddWxaAction4() {
        let params = {wxaAppId: this.detail.authorizer_appid}
        grayReleaseDebug(params).then(res=>{
          let msg = res.data.errmsg;
          this.$message({
            message:msg,
            type:'success',
            duration: 3*1000
          })
        })
      },
      //分阶段发布全部
      handleAddWxaAction5() {
        let params = {wxaAppId: this.detail.authorizer_appid}
        grayReleaseAll(params).then(res=>{
          let msg = res.data.errmsg;
          this.$message({
            message:msg,
            type:'success',
            duration: 3*1000
          })
        })
      },
      //分阶段发布详情
      handleAddWxaAction6() {
        let params = {wxaAppId: this.detail.authorizer_appid}
        getgrayReleaseDetail(params).then(res=>{
          let msg = res.data.data.msg;
          this.$message({
            message:msg,
            type:'success',
            duration: 6*1000
          })
        })
      },
      //取消分阶段发布
      handleAddWxaAction8(){
        let params = {wxaAppId: this.detail.authorizer_appid}
        revertGrayRelase(params).then(res=>{
          let msg = res.data.data.msg;
          this.$message({
            message:msg,
            type:'success',
            duration: 6*1000
          })
        })
        
      },
      //当前版本
      handleAddWxaAction7(){
        let params = {wxaAppId: this.detail.authorizer_appid}
        getnowVersion(params).then(res=>{
          let msg = res.data.data.msg;
          this.$message({
            message:msg,
            type:'success',
            duration: 6*1000
          })
        })
      },
      // 查看审核状态
      // getAuditStatus(){
      //   let params = {wxaAppId: this.detail.authorizer_appid}
      //   getWxaAuditStatus(params).then(response => {
          
      //   })
      // },
      // 查看可以回退的小程序版本
      getListrevertcoderelease(){
        this.showRevertReleas = true;
        let params = {wxaAppId: this.detail.authorizer_appid}
        getListrevertcoderelease(params).then(res=>{
          this.CanRevertRelasList = res.data.data.list
        })
      }, 
      // 回退指定版本
      versionRevertcoderelease(app_version){
        let params = {wxaAppId: this.detail.authorizer_appid,app_version:app_version}
        versionRevertcoderelease(params).then(res=>{
          // var status =  response.data.data.status
          var msg = response.data.data.status_msg
          this.$message({
            message:msg,
            type:'success',
            duration: 3*1000
          })
        })
      },
      // 查看最后一次提交审核状态
      getLastAuditStatus(){
        let params = {wxaAppId: this.detail.authorizer_appid}
        console.log(params)
        getLastAuditStatus(params).then(response=>{
          var status =  response.data.data.status
          var msg = response.data.data.status_msg
          this.$message({
            message:msg,
            type:'success',
            duration: 5*1000
          })
        })
      },
      tryRelease () {
        let params = {wxaAppId: this.detail.authorizer_appid}
        tryRelease(params).then(response => {
          this.$message({
            message: response.data.data.message,
            type: 'success',
            duration: 5 * 1000
          })
          this.getWxa()
        })
      },
      downloadWxaCode () {
        this.getwxcodeloading = true
        let params = {wxaAppId: this.detail.authorizer_appid}
        getCodeUnlimit(params).then(response => {
          this.wxaCodeImage = response.data.data.base64Image
          this.wxaCodeVisible = true
          this.getwxcodeloading = false
        })
        .catch(error => {
          this.getwxcodeloading = false
        })
      }
    },
    mounted () {
      if (!this.wxapp_id && this.$route.query && this.$route.query.newBind) {
        let params = {wxaAppId: this.$route.query.wxapp_id, wxa_name: this.$route.query.nick_name, templateName: this.template_name}
        submitWxa(params).then(response => {
          this.$message({
            message: '提交成功，等待微信审核',
            type: 'success',
            duration: 5 * 1000
          })
          getWxa(this.$route.query.wxapp_id).then(response => {
            this.detail = response.data.data
            this.$store.dispatch('setWxappId', this.$route.query.wxapp_id)
            this.$router.push({path: this.matchInternalRoute('editauthorize')})
          })
        })
      } else {
        if (this.wxapp_id) {
          this.loading = true
          getWxa(this.wxapp_id).then(response => {
            this.detail = response.data.data
            this.loading = false
          })
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .app-img {
    width: 90px;
    height: auto;
    margin: 10px;
  }
  .app-name {
    font-size: 20px;
    font-weight: 500;
  }
  .info-list {
    padding: 30px 0;
    .info-item {
      font-size: 14px;
      .label {
        width: 100px;
        height: 50px;
        line-height: 50px;
        float: left;
        color: #ccc;
      }
      .content {
        display: flex;
        align-items: center;
        height: 50px;
        margin-left: 120px;
        border-bottom: 1px solid #efefef;
        .content-item {
          flex: 1;
        }
      }
    }
  }
  .demo {
    padding: 30px;
  }
  .demo-qrcode {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 50px;
    height: 50px;
    margin: 0 auto;
    transition: all 0.3s ease;
    transform: scale(1);
    background: #fff;
    border-radius: 50%;
    box-shadow: 0 0 5px rgba(0,0,0,0.3);
    overflow: hidden;
    cursor: pointer;
    &:hover {
      transform: scale(1.1);
    }
    img {
      display: block;
      width: 70%;
      height: 70%;
    }
  }
  .no-bind {
    color: #ccc;
  }
</style>



// WEBPACK FOOTER //
// index.vue?13eaabba